import { VBreadcrumbs } from 'vuetify/lib/components/VBreadcrumbs';

var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(VBreadcrumbs,_vm._b({staticClass:"px-0",attrs:{"items":_vm.breadcrumbs}},'v-breadcrumbs',_vm.$attrs,false))
}
var staticRenderFns = []

export { render, staticRenderFns }